<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

// Report pages default to a centered, max-w-5xl reading column (right for charts/tables). A
// route can opt out via `meta.fullBleed` — e.g. campaigns_reports, which embeds an external
// app via iframe and wants the whole available area instead of a narrow column with large
// empty gutters either side.
const route = useRoute();
const isFullBleed = computed(() => !!route.meta.fullBleed);
</script>

<template>
  <div
    class="overflow-auto bg-n-surface-1 w-full"
    :class="isFullBleed ? 'h-full px-0' : 'px-6'"
  >
    <div
      class="w-full"
      :class="isFullBleed ? 'h-full flex flex-col' : 'max-w-5xl mx-auto pb-12'"
    >
      <router-view />
    </div>
  </div>
</template>
